// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2s146","left":"InfoRow_left__1zY-e"};